import { ViewController } from 'ionic-angular/navigation/view-controller';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { BllStoklar } from './../../../providers/bll/bll-stoklar';
import { BllViewStoklar } from './../../../providers/bll/bll-ViewStoklar';
import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';


@Component({
  selector: 'page-hizli-fiyat-degistir',
  templateUrl: 'hizli-fiyat-degistir.html',
})
export class HizliFiyatDegistirPage {
  aranan = "";
  stoklistesi = [];
  stokadi = "";
  fiyatlar: any = { ID:"",Price: "", Price2: "", Price3: "", Price4: "",StokAdi:"" }
  yenifiyat: number = 0;
  constructor(public navCtrl: NavController,
    public bllOrtak: BllOrtak,
    public ortak: Ortak,
    public viewCtrl: ViewController,
    public navParams: NavParams) {
  }

  ionViewDidLoad() {

  }
  UrunAraDB()
  {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    console.log("ara1",this.aranan);
    this.bllOrtak.islem(formData, "StokBulBarkod", "", false).then(a => {
      var sonuc = <any>a;
      this.stoklistesi = sonuc.SonucObject;
      console.log("ara1",this.aranan);
console.log("ara21",this.stoklistesi);
 
if (this.stoklistesi.length == 1) {
  this.stoklistesi.forEach(e => {
    this.fiyatlar.Price1 = e.Price1;
    this.fiyatlar.Price2 = e.Price2;
    this.fiyatlar.Price3 = e.Price3;
    this.fiyatlar.Price4 = e.Price4;
    this.stokadi = e.StokAdi;
    this.fiyatlar.ID=e.ID;
  })
}
      // this.fiyatlar.Price1 = this.stoklistesi[0].Price1;
      // this.fiyatlar.Price2 = this.stoklistesi[0].Price2;
      // this.fiyatlar.Price3 = this.stoklistesi[0].Price3;
      // this.fiyatlar.Price4 = this.stoklistesi[0].Price4;
      // this.stokadi = this.stoklistesi[0].StokAdi;
      // this.fiyatlar.ID=this.stoklistesi[0].ID;
 
})



 
}
  urunAra() {
    console.log("ara1",this.aranan);
    var bllstok = new BllStoklar();
    bllstok.getAllWithSpecificQuery("(Barcode1='" + this.aranan + "')").then(a => {
      this.stoklistesi = a;
      if (this.stoklistesi.length == 1) {
        this.stoklistesi.forEach(e => {
          this.fiyatlar.Price1 = e.Price1;
          this.fiyatlar.Price2 = e.Price2;
          this.fiyatlar.Price3 = e.Price3;
          this.fiyatlar.Price4 = e.Price4;
          this.stokadi = e.StokAdi;
          this.fiyatlar.ID=e.ID;

        })
      }
    });
  }
  urunler(e) {
    if (e.keyCode == 13) {
      this.urunAra();
    }
  }

  Kaydet() {
    var stok = new BllStoklar();
    stok.FiyatlariGuncelle(this.fiyatlar).then(a => {

    });
    var stokview=new BllViewStoklar();
    stokview.FiyatlariGuncelle(this.fiyatlar).then(a=>{

    });
    var formdata=new FormData();
    console.log("ff",this.fiyatlar)
    formdata.append("Stok_json",JSON.stringify(this.fiyatlar));
    this.bllOrtak.islem(formdata,"HizliFiyatDegistir","Lütfen Bekleyiniz",true).then(a=>{
      var sonuc=<any>a;
      if(sonuc.Sonuc==1)
      {
        this.ortak.showBasicAlert("Başarılı","Fiyatlar başarı bir şekilde değiştirildi");
        this.viewCtrl.dismiss();
      }
      if(sonuc.Sonuc!=1)
      {
        this.ortak.showBasicAlert("Hata","Beklenmedik bir hata oluştu");
      }
    })
  }
  Kapat() {
    this.viewCtrl.dismiss();
  }







}



// WEBPACK FOOTER //
// ./src/pages/PerakendeIslemleri/hizli-fiyat-degistir/hizli-fiyat-degistir.ts